var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_done",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.565,
    height: 15.823,
    viewBox: "0 0 16.565 15.823",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_56",
    d: "M489.94,306.438a7.911,7.911,0,1,1,4.528-14.4l.427.3-.6.854-.426-.3a6.871,6.871,0,1,0,2.939,5.635,6.93,6.93,0,0,0-.16-1.483l-.112-.508,1.017-.223.112.508a8,8,0,0,1,.185,1.706,7.92,7.92,0,0,1-7.911,7.911",
    transform: "translate(-482.029 -290.615)",
    fill: "#d8262f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_57",
    d: "M492.949,302.522a.518.518,0,0,1-.366-.151l-3.6-3.564.732-.74,3.2,3.166,7.815-9.35.8.667-8.177,9.785a.523.523,0,0,1-.375.186h-.024",
    transform: "translate(-484.961 -291.15)",
    fill: "#d8262f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDone);
export default __webpack_public_path__ + "static/media/icon_done.e172ce77fb40bd096bbe25a4569ec41a.svg";
export { ForwardRef as ReactComponent };